import api from './api';
import { API_ROUTES } from '../config/apiRoutes';

export const jobService = {
  getJobs: async () => {
    try {
      return await api.get(API_ROUTES.jobs.list);
    } catch (error) {
      console.error('Error fetching jobs:', error);
      throw error;
    }
  },
  
  getJob: async (id) => {
    try {
      return await api.get(`${API_ROUTES.jobs.list}/${id}`);
    } catch (error) {
      console.error('Error fetching job:', error);
      throw error;
    }
  },
  
  createJob: async (jobData) => {
    try {
      return await api.post(API_ROUTES.jobs.create, jobData);
    } catch (error) {
      console.error('Error creating job:', error);
      throw error;
    }
  },
  
  updateJob: async (id, jobData) => {
    try {
      return await api.put(API_ROUTES.jobs.update(id), jobData);
    } catch (error) {
      console.error('Error updating job:', error);
      throw error;
    }
  }
};
